import * as React from "react";
const SvgXWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <g fill="#fff" fillRule="evenodd" clipRule="evenodd">
      <path d="M10.434 10.434a.8.8 0 0 1 1.132 0l17 17a.8.8 0 0 1-1.132 1.132l-17-17a.8.8 0 0 1 0-1.132" />
      <path d="M28.566 10.434a.8.8 0 0 1 0 1.132l-17 17a.8.8 0 0 1-1.132-1.132l17-17a.8.8 0 0 1 1.132 0" />
    </g>
  </svg>
);
export default SvgXWhite;
